import storage from 'good-storage'
import { getLogoUrl } from 'utils/util'
import {
  SET_COLLAPSED,
  SET_COMPANY,
  SET_CLIENTID,
  SET_BUREAU,
  SET_CUSTOMER_INFO,
  SET_CUSTOMER_DETAIL,
  SET_CODE,
  SET_PERMISSIONS,
  SET_LOGO_URL,
  SET_SYS_NAME,
} from 'config/mutation-types/app'

const app = {
  namespaced: true,
  state: {
    collapsed: false,
    bureauReportBasicInfo: storage.get('bureauReportBasicInfo') || {},
    company: storage.get('company') || {},
    clientId: '',
    customerInfo: {},
    customerDetail: {},
    code: '',
    permissions: storage.get('permissions') || {},
    logoUrl: getLogoUrl(),
    sysName: storage.get('sysName') || '',
  },
  mutations: {
    [SET_COLLAPSED](state, collapsed) {
      state.collapsed = collapsed
    },
    [SET_BUREAU](state, bureauReportBasicInfo) {
      state.bureauReportBasicInfo = bureauReportBasicInfo
    },
    [SET_COMPANY](state, company) {
      state.company = company
    },
    [SET_CLIENTID](state, clientId) {
      state.clientId = clientId
    },
    [SET_CUSTOMER_INFO](state, customerInfo) {
      state.customerInfo = customerInfo
    },
    [SET_CUSTOMER_DETAIL](state, customerDetail) {
      state.customerDetail = customerDetail
    },
    [SET_CODE](state, code) {
      state.code = code
    },
    [SET_PERMISSIONS](state, permissions) {
      state.permissions = permissions
    },
    [SET_LOGO_URL](state, logoUrl) {
      state.logoUrl = logoUrl
    },
    [SET_SYS_NAME](state, sysName) {
      state.sysName = sysName
    },
  },
  getters: {
    collapsed(state) {
      return state.collapsed
    },
    company(state) {
      return state.company
    },
    bureauReportBasicInfo(state) {
      return state.bureauReportBasicInfo
    },
    clientId(state) {
      return state.clientId
    },
    customerInfo(state) {
      return state.customerInfo
    },
    customerDetail(state) {
      return state.customerDetail
    },
    code(state) {
      return state.code
    },
    permissions(state) {
      return state.permissions
    },
    logoUrl(state) {
      return state.logoUrl
    },
    sysName(state) {
      return state.sysName
    },
  },
}

export default app
